<div mat-dialog-content class="dealers">
    <!-- <h1 mat-dialog-title>Select a dealer to view their dashboard</h1> -->
    <!-- <mat-form-field class="searchbox">
        <input matInput (keyup)="searchGroups()" placeholder="Search..." [(ngModel)]="searchValue">
    </mat-form-field> -->
    <div class="header4">
        {{plaintext.viewReportsOf.header1[language]}} <span *ngIf="!isPSC">{{plaintext.viewReportsOf.header2[language]}}</span> {{plaintext.viewReportsOf.header3[language]}}
    </div>
    <div class="dialog-container" *ngIf="currentStep == 1">
        <!-- <app-data-table *ngIf="!isDealersLoading" [displayedColumns]="dealerColumns" [tableData]="dealers"
            [initSortColumn]="0" [initSortDirection]="'asc'" [selectable]="true" [selection]="selection">
        </app-data-table> -->
        <div class="subtitle1" style="margin-top: 10px">Select a dealership</div>
        <app-choose-users-table *ngIf="dealers != null && userType === 'dealeradmin'" [selection]="selection" [dealerTableHeight]="'350px'"
            [(selectedRegionFilter)]="selectedRegionFilter" [(selectedZoneFilter)]="selectedZoneFilter" [(selectedDistrictFilter)]="selectedDistrictFilter"
            [dealers]="dealers" [currentOffset]="currentOffset" [currentTake]="currentTake"></app-choose-users-table>
    </div>
    <div class="dialog-container" *ngIf="currentStep == 2">
        <div *ngIf='!isPSC'>
            <div class="subtitle1" style="margin-top: 10px">Selected dealership: {{ selection.selected[0].name }}</div>
            <div class="view-as-psc-box">
                <mat-checkbox (change)="setViewAsPSC()" [checked]="viewAsPSC">
                </mat-checkbox>
                <p class="view-as-psc-text">View as a PSC admin</p>
            </div>
            <div class="view-as-psc-box">
                <mat-checkbox (change)="setViewAsPSC()" [checked]="viewAsEmployee">
                </mat-checkbox>
                <p class="view-as-psc-text">View as a specific employee of {{ selection.selected[0].name }}</p>
            </div>
        </div>
        <div *ngIf="viewAsEmployee">
            <mat-progress-bar mode="indeterminate" *ngIf="isDealersLoading"></mat-progress-bar>
            <div style="display: flex;">
                <mat-form-field *ngIf="!isDealersLoading" appearance="fill" class="searchbox">
                    <input id="searchInput" matInput [ngModel]="employeeSearchInput"
                        (keyup)="searchEmployees($event.target.value)" [placeholder]="employeeSearchText">
                </mat-form-field>
                <button mat-button *ngIf="!isDealersLoading" (click)="refreshEmpoloyees()"><i-feather class="nav-icon" name="refresh-cw"></i-feather></button>
            </div>
            <app-data-table *ngIf="!isDealersLoading" [displayedColumns]="employeeColumns" [tableData]="employees" 
                [initSortColumn]="0" [initSortDirection]="'asc'" [selectable]="true" [selection]="employeeSelection"
                [height]="'450px'">
            </app-data-table>
        </div>
    </div>
</div>
<div mat-dialog-actions class="button-container">
    <button mat-raised-button (click)="onNoClick()">{{plaintext.close[language]}}</button>
    <div>
        <button *ngIf="currentStep == 2 && !isPSC" mat-raised-button cdkFocusInitial (click)="back()">Back</button>
        <button *ngIf="currentStep == 1" mat-raised-button cdkFocusInitial (click)="next()"
            [disabled]="selection.selected.length < 1" color="accent" id="goBtn">Next</button>
        <button *ngIf="currentStep == 2 && isPSC" mat-raised-button cdkFocusInitial (click)="go()"
            [disabled]="employeeSelection.selected.length == 0" color="accent"
            id="goBtn">{{plaintext.go[language]}}</button>
        <button *ngIf="currentStep == 2 && !isPSC" mat-raised-button cdkFocusInitial (click)="go()" 
            [disabled]="viewAsPSC == false && employeeSelection.selected.length == 0" color="accent"
            id="goBtn">Go</button>
    </div>
</div>